import React, { Component } from 'react';
import { connect } from 'react-redux';
import usersActions from '../../../../../actions/users.actions';
import ResetPasswordPage from './ResetPasswordPage';

export class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: '',
      loading: false,
      settings: null,
      user: null,
    };
  }

  componentDidMount() {
    const { userId } = this.props.match.params;
    usersActions
      .getUserDetail(userId)
      .then((user) =>
        usersActions
          .getDeptSettings(user.departmentId)
          .then((settings) => this.setState({ settings, user })),
      );
  }

  onResetPassword = (values) => {
    const { userId } = this.props.match.params;
    this.setState({ loading: true, error: '' }, async () => {
      await this.props
        .resetPassword(userId, values)
        .then(() =>
          this.setState({ loading: false }, () =>
            this.props.history.push('/configure/users'),
          ),
        )
        .catch((error) => this.setState({ loading: false, error: error }));
    });
  };

  render() {
    return (
      <ResetPasswordPage
        onResetPassword={this.onResetPassword}
        {...this.state}
      />
    );
  }
}

export default connect(null, usersActions)(ResetPassword);
